import { makeStyles } from '@mui/styles';
import Tabs from 'apollo-react/components/Tabs';
import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { setSelectedControlObject, setSelectedTabIndex } from './actions/report-designer.actions';
import {
  REPORT_CONTROL_TYPE,
  REPORT_LAYOUT_ID,
  TABS_HEIGHT,
  TABS_MARGIN_BOTTOM,
} from './constants/report-designer.constants';
import SSDistributionContent from './controls/ssDistributionContent';
import DynamicControl from './DynamicControl';
import { getRootControls, getSelectedTabIndex } from './selectors/report-designer.selectors';
import { PILGRIM_TOP_MENU_HEIGHT } from '../constants/SizeConstants';
import { equalityFn } from '../form-designer/utils/form-manager.utils';

const useStyles = makeStyles({
  tabs: {
    marginBottom: TABS_MARGIN_BOTTOM,
  },
  container: {
    height: ({ headersHeight }) => `calc(100vh - ${headersHeight}px)`,
    overflow: 'auto',
  },
});

const ReportManager = ({ headerHeight }) => {
  const headersHeight = headerHeight + PILGRIM_TOP_MENU_HEIGHT + TABS_HEIGHT + TABS_MARGIN_BOTTOM;

  const dispatch = useDispatch();
  const classes = useStyles({ headersHeight });
  const rootControls = useSelector(getRootControls, equalityFn);
  const selectedTabIndex = useSelector(getSelectedTabIndex);

  const handleTabChange = (_, tabValue) => {
    batch(() => {
      dispatch(setSelectedTabIndex(tabValue));
      tabValue === 0 && dispatch(setSelectedControlObject(REPORT_LAYOUT_ID, false));
    });
  };

  const isDistributionTab =
    rootControls[selectedTabIndex].id === REPORT_CONTROL_TYPE.DISTRIBUTION_TAB;

  return (
    <>
      <Tabs className={classes.tabs} value={selectedTabIndex} onChange={handleTabChange}>
        {rootControls.map(({ id }, i) => (
          <DynamicControl key={id} id={id} tabIndex={i} />
        ))}
      </Tabs>
      <div className={classes.container}>
        {isDistributionTab ? (
          <SSDistributionContent id={rootControls[selectedTabIndex].id} />
        ) : (
          rootControls[selectedTabIndex].childrenNodes.map((id) => (
            <DynamicControl key={id} id={id} />
          ))
        )}
      </div>
    </>
  );
};

export default ReportManager;
